import * as React from 'react';
import {LOAN_APPLICATION, LOAN_APPLICATION_MX} from '../../../../constants/LabelConstants';
import AssetsManager from '../../../../../common/utils/AssetsManager';
import Button from '../../../../../common/components/Button';
import {ThanksProps} from '../../../../types/mx/turboCash/components';

class TurboCashThanksView extends React.Component<ThanksProps, {}> {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            landing
        } = this.props;
        return (
            <div className={`container ${landing ? 'wizard-landing landing-turbo-cash' : ''}`}>
                <h3 className="text-raleway text-secondary-lighten-1">Tu auto financiado a un paso</h3>
                <span className="regular-text sub-title">Recuerda que ya tienes tu crédito pre aprobado!</span>
                <div className="row py-5">
                    <div className="col-md-8 offset-md-2">
                        <div className="row mb-5">
                            <div className="col text-center">
                                <img src={AssetsManager('/assets/images/common/success-icon.svg')}/>
                            </div>
                        </div>
                        <div className="row mb-3 mt-3">
                            <div className="col text-center">
                                <h4 className="text-raleway text-secondary-lighten-1">
                                    {LOAN_APPLICATION.TITLE_THANKS_COMPLETE}
                                </h4>
                            </div>
                        </div>
                        <div className="row p-none mb-5">
                            <div className="col text-center">
                                {LOAN_APPLICATION.SUCCESS_TEXT_TURBO_CASH}
                            </div>
                        </div>
                        <div className="row p-none">
                            <div className="col d-flex justify-content-center">
                                <Button onPress={this.props.onPressGotoHome} text={LOAN_APPLICATION_MX.GOTO_HOME}
                                        customClass="px-5"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default TurboCashThanksView;